<template>
  <div v-loading="loading" class="set">
    <div class="form-group-title"><span class="ogc-icon-font ogc-icon-mefill"></span> 设置</div>
    <div class="user-info">
      <div class="custom-info">
        <h1>{{ user.UserName }}</h1>
      </div>

    </div>

    <div class="form-group-title"><span class="ogc-icon-font ogc-icon-jurassic_quanxian"></span> 帐号安全设置</div>
    <div class="account-info">

      <phone :phone="user.PhoneNumberStr" :CustomId="user.CustomId" @saved="loadData" :email="user.ContractsEmail"
             :username="user.UserName" :phoneStr="user.PhoneNumber"></phone>

      <!--<bank-card :card="user.Account" @saved="loadData" :bank="user.BankName" :username="user.UserName" v-if="user.IsManager"></bank-card>-->

      <div class="item" v-if="false">
        <div class="item-icon">
          <span class="ogc-icon-font ogc-icon-credentials_icon"></span>
        </div>
        <div class="item-info">
          <p class="strong">身份证认证</p>
          <p>完善身份证信息，便于进行购买操作</p>
        </div>
      </div>

      <password :phone="user.PhoneNumber" @saved="loadData" :CustomId="user.CustomId" :email="user.ContractsEmail"
                :password="user.PasswordLength" :phoneStr="user.PhoneNumber" :oldPassword="user.Password"
                :username="user.UserName"></password>
      <!--      <email :phone="user.PhoneNumber" @saved="loadData" :email="user.ContractsEmail" :username="user.UserName"></email>-->
      <div class="item">
        <div class="item-icon">
          <span class="ogc-icon-font ogc-icon-hetong" v-if="!PaymentPassword"></span>
          <span class="ogc-icon-font ogc-icon-hetong colo" v-else></span>
        </div>
        <div class="item-info">
          <p class="strong">支付密码</p>
          <p>{{ Title }}</p>

        </div>
        <div style="float: right;line-height: 50px">
          <el-button class="button" size="small" type="primary" round plain @click="changePayPWD"
                     >{{
              Title }}
          </el-button>
        </div>
      </div>
    </div>
    <el-dialog center
               :title='Title'
               :visible.sync="dialogVisible"
    >
      <el-form ref="PayForm" :model="PayForm" label-width="135px" :rules="PayRules">
        <el-form-item label="手机号：">
          {{ PayForm.Phone }}
        </el-form-item>
        <el-form-item label="验证码：" prop="VCode">
          <el-input v-model="PayForm.VCode" placeholder="手机验证码" style="width: 84%;"></el-input>
          <el-button alt="" class="v-code" @click="sendVCode" :disabled="sendVCodeTime > 0">
            {{ sendVCodeTime > 0 ? sendVCodeTime + " 秒" : "发送验证码" }}
          </el-button>
        </el-form-item>
        <el-form-item label="请输入新密码：" prop="Password">
          <el-input v-model="PayForm.Password" placeholder="请输入新密码" clearable type="password"></el-input>
        </el-form-item>
        <el-form-item label="再次输入新密码：" prop="RePassword">
          <el-input v-model="PayForm.RePassword" placeholder="再次输入新密码" clearable type="password"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="savePayPwd">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">

import UserInfo from '@/components/UserInfo'
import DialogForm from '@/components/Dialogs/DialogForm'

import Company from './components/Company'
import Phone from './components/ChangePhone'
import Password from './components/ChangePassword'
import Email from './components/ChangeEmail'
import BankCard from './components/ChangeBankCard'


import Qualification from './components/Qualification'

export default {
  components: {
    UserInfo, DialogForm, Password, Phone, Email, BankCard, Qualification, Company
  },
  props: {
    screen: {
      type: Object,
      default: () => {
      }
    },
  },
  data() {
    // if(!reg.test(value)){
    //   callback(new Error('请输入整数'));
    // }else {
    //   callback();
    // }
    var checkedPayRePwd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入支付密码'));
      } else if (value !== this.PayForm.Password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    var checkedPayPWD = (rule, value, callback) => {
      let reg = /^[0-9]\d{5}$/;
      if (value === '') {
        callback(new Error('请输入六位数字的支付密码'));
      } else if (!reg.test(value)) {
        callback(new Error('请输入六位数字的支付密码'));
      } else {
        callback();
      }
    };
    return {
      user: {
        Account: null,
        ContractsCardNumber: null,
        ContractsEmail: null,
        CustomNo: null,
        Name: null,
        CustomId: null,
        EmpName: null,
        UserName: null,
        PasswordLength: null,
        PhoneNumber: null,
        DonationQuota: 0,
        BankName: null,
        Company: null,
        IsManager: false,
        CanUseMoney: null,
        CompanyState: null,
        RealNameState: null,
        PhoneNumberStr: null,
        Password: null,
      },
      Title: '',
      sendVCodeTime: '',
      PayRules: {
        Password: [
          {
            required: true,
            message: '请输入新支付密码',
            trigger: 'blur'
          },
          {
            validator: checkedPayPWD,
          }
        ],
        RePassword: [
          {
            required: true,
            message: '请再次输入新支付密码',
            trigger: 'blur'
          },
          {
            validator: checkedPayRePwd,
          }
        ],
        VCode: [
          {
            required: true,
            message: '请输入验证码',
            trigger: 'blur'
          },
          // {
          //   min: 6,
          //   max: 10,
          //   message: '客户号长度应在 6 到 10 个字符之间',
          //   trigger: 'blur'
          // }
        ],
      },
      qs: [],
      url: {
        loadData: SZH.assets.api + "/Custom/GetCustomInfoForWeb",
        loadQs: SZH.assets.api + "/Authen/GetCustomQualificationsInfo",
        SendVerifyCodeForWeb: SZH.assets.api + "/Custom/SendVerifyCodeForWeb",//支付密码的验证码发送
        SetCustomPaymentPassword: SZH.assets.api + "/Custom/SetCustomPaymentPassword",//支付密码保存
        edit: SZH.assets.api + '/Authen/SaveNewCustomNo',
        saveApplication: SZH.assets.api + '/Custom/SaveCustomGetMoneyApplyForWeb',
      },
      formTemplate: [
        {col: 24, label: '客户号', prop: 'CustomNo', default: ''},
      ],
      visible: false,
      dialogVisible: false,
      PaymentPassword: '',
      form: {
        CustomNo: null,
      },
      PayForm: {
        Phone: '15253645757',
        Password: '',
        RePassword: '',
        VCode: '',
        PaymentPassword: ''
      },
      rules: {
        CustomNo: [
          {
            required: true,
            message: '请输入客户号',
            trigger: 'blur'
          },
          {
            min: 6,
            max: 10,
            message: '客户号长度应在 6 到 10 个字符之间',
            trigger: 'blur'
          }
        ],
      },
      ApplicationForm: {
        Amount: '',
        Reason: ''
      },
      ApplicationFormTemplate: [
        {col: 24, label: '金额', prop: 'Amount'},
        {col: 24, label: '备注', prop: 'Reason', type: 'textarea'}
      ],
      ApplicationRules: {
        Amount: [
          {required: true, message: '请输入金额', trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              var reg = /^[0-9]\d*$/;
              if (!reg.test(value)) {
                callback(new Error('请输入整数'));
              } else {
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
      },
      ApplicationVisible: false,
      loading: true,
    }
  },
  methods: {
    changePayPWD() {
      let self = this
      self.dialogVisible = true
      self.PayForm.Phone = self.user.PhoneNumberStr
      self.PayForm.PaymentPassword = self.user.PaymentPassword;
      self.$nextTick(()=>{
        self.$refs['PayForm'].resetFields();
      })
    },
    sendVCode() {
      let self = this;
      self.sendVCodeTime = 60;
      self.getCode()
      localStorage.setItem("sendvcodetime", 60);
      let index = setInterval(() => {
        if (self.sendVCodeTime > 0) {
          localStorage.setItem("sendvcodetime", --self.sendVCodeTime);
        } else {
          clearInterval(index)

          localStorage.removeItem("sendvcodetime")
        }
      }, 1000);
    },
    getCode() {
      let self = this;
      self.$http.post(self.url.SendVerifyCodeForWeb, {
        SmsTemplateType: 6,
        Phone: self.user.PhoneNumber,
        CustomId: self.user.CustomId,
        OldPassword: self.user.Password,
        Captcha: '',
      }).then(result => {
        if (result.state == true) {
          self.$message.success("验证码已发送成功")
        } else {
          self.$message.error(result.message)
        }
      })
    },
    savePayPwd() {
      let self = this;
      self.$refs['PayForm'].validate((valid) => {
        if (valid) {
          let NewPassword = hex_md5(self.PayForm.Password);
          let NewRePassword = hex_md5(self.PayForm.RePassword);
          self.loading  = true;
          self.$http.post(self.url.SetCustomPaymentPassword, {
            Password: NewPassword,
            RePassword: NewRePassword,
            VCode: self.PayForm.VCode,
            OldPassword: self.PayForm.PaymentPassword
          }).then(result => {
            if (result.state == true) {
              self.$message.success('修改支付密码成功');
              location.reload()
            } else {
              self.$message.error(result.message)
            }
            self.loading  = false;
          })
        } else {
          self.loading  = false;
          return false;
        }
      });

    },
    toFixed(number) {
      var num = parseFloat(number == null ? 0 : number);
      return num != null && num != undefined ? num.toFixed(2) : '0.00'
    },
    loadMoney() {
      var self = this;
      self.loading = true;
      self.$http.post(self.url.get, {}).then(result => {
        if (result.State == 1 && result.Data != null) {
          this.money = result.Data;
        } else {
        }
        self.loading = false;
      }, () => {
        self.loading = false;
      });
    },
    loadData() {
      var self = this;
      self.loading = true;
      self.$http.post(self.url.loadData, {}).then(result => {
        if (result.state == true && result.data != null) {
          for (var i in self.user) {
            if (result.data[i] != undefined) {
              self.user[i] = result.data[i];
            } else {
              self.user[i] = null;
            }
          }
          self.PaymentPassword = result.data.PaymentPassword;
          if (self.PaymentPassword) {
            self.Title = '修改支付密码'
          } else {
            self.Title = '设置支付密码'
          }
        } else {
        }
        self.loading = false;
      }, () => {
        self.loading = false;
      });
    },
    loadQs() {
      var self = this;
      self.$http.post(self.url.loadQs, {}).then(result => {
        if (result.State == 1 && result.Data != null) {
          self.qs = result.Data;
        } else {
        }
      }, () => {
      });
    },
    onRemoveAccount() {
      var self = this;
      self.$confirm('继续该操作将永久删除您账号下的所有数据，包括子账号的数据，您确定要这么做吗？', '警告', {
        confirmButtonText: '我确定',
        cancelButtonText: '我点错了',
        type: 'warning',
        center: true
      }).then(() => {
        localStorage.clear();
        sessionStorage.clear();
        self.$confirm('继续该操作将永久删除您账号下的所有数据，该操作不可逆，删除后数据无法找回，您真的要这么做吗？', '再次警告', {
          confirmButtonText: '是的，我非常确定',
          cancelButtonText: '我需要再考虑一下',
          type: 'warning',
          center: true
        }).then(() => {
          this.$loading({
            text: '很遗憾您这么做，我们正在删除您账户的数据，稍后将跳转到登录页面，请耐心等待...',
            spinner: 'el-icon-loading',
            background: 'rgba(255,255,255, 0.85)'
          });
          setTimeout(() => {
            location.href = "/Login";
          }, 5000);
        }).catch(() => {
          self.$message.success("很高兴可以继续为您服务！");
        });

      }).catch(() => {
        self.$message.success("很高兴可以继续为您服务！");
      });
    },
    onShowInfo() {
      // 跳转
      this.$router.push({
        path: '/My/UserInfo'
      });
    },
    // 修改客户号弹框
    editCustomNo() {
      this.formTemplate[0].default = this.user.CustomNo;
      this.visible = true;
    },
    // 保存
    onEdit() {
      this.$message.success('客户号修改成功！');
      this.loadData();
    },
    // 申请
    Application() {
      //this.ApplicationVisible = true;
      // 提现申请跳转
      this.$router.push({
        path: '/My/Cash'
      });
    },
    // 申请保存
    onApplication() {
      this.$message.success('提现申请成功！');
      this.loadData();
    },
    // 充值跳转
    Charge() {
      this.$router.push({
        path: '/Charge'
      });
    },
    bindBankCard() {
      this.$router.push({
        path: '/My/BankCard'
      });
    }
  },
  computed: {},
  created() {
  },
  mounted() {
    this.loadData();
    // this.loadQs();
  },
  watch: {}
}
</script>

<style type="text/css" scoped>

.form-group-title:not(:first-child) {
  margin-top: 15px;
}

.set > .user-info {
  position: relative;
  overflow: hidden;
  padding: 0 30px;
  height: 130px;
}

.user-info > .user-icon {
  /*float: left;*/
  background-color: #E0E0E0;
  width: 100px;
  height: 100px;
  padding: 10px;
  border-radius: 50%;
  position: absolute;
  right: 0;
}

.user-info > .user-icon > img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}

.set > .user-info > .custom-info {
  /* float: right;
  background-color: #E0E0E0; */
  height: 130px;
  /*  width: calc(100% - 200px);*/
  padding: 10px;
  position: absolute;
  left: 0;
}

.user-info > .custom-info > h1 {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 10px;
}

.user-info > .custom-info > div > p {
  line-height: 25px;
}

.user-info > .custom-info > div > p.assets > span {
  color: #0A529C
}

.user-info > .custom-info > div > p.assets > span:not(:first-child) {
  margin-left: 25px;
}

.account-info {
  overflow: hidden;
}

.item {
  float: left;
  overflow: hidden;
  width: calc(50% - 20px);
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid #AAA;
}

.item:nth-child(2n) {
  float: right;
}

.item > .item-icon {
  float: left;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
}

.item > .item-icon > .ogc-icon-font {
  color: #AAA;
  font-size: 36px;
}

.item > .item-icon > .colo {
  color: #00b1ff;
  font-size: 36px;
}

.item.active > .item-icon > .ogc-icon-font {
  color: #00B1FF;
}

.item > .item-icon > .colo {
  color: #00B1FF !important;

}

.item > .item-info {
  float: left;
  padding: 5px;
}

.item > .item-info > p {
  line-height: 20px;
}

.item > .item-info > p.strong {
  font-weight: 700;
}

.item > .buttons {
  float: right;
  line-height: 50px;
}
</style>
<style>
#app > .layout > .contents > .contents > .right-body > div > .account-info > .item > .buttons > button {
  padding: 5px 10px;
}

.v-code-input {
  width: calc(100% - 120px - 10px);
  display: inline-block;
}
.button1{
  padding-top: 14px;
  padding-bottom: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/Me/Info/Set.vue